export const SUBSCRIPTION_ROUTES = {
  list: '/subscriptions',
  subjectPlans: '/subscriptions/subject-plans',
  subjectDetail: '/subscriptions/subject-plan-detail',
  examPlans: '/subscriptions/exam-plans',
  examDetail: '/subscriptions/exam-plan-detail',
  assessmentPlans: '/subscriptions/assessment-plans',
  assessmentDetail: '/subscriptions/assessment-plan-detail',
  assessmentReattempts: '/subscriptions/assessment-reattempts',
  rapidFireAttempts: '/subscriptions/rapid-fire-attempts',
  coinStore: '/subscriptions/coin-store',
  coinHistory: '/subscriptions/coin-history',
  paymentMethod: '/subscriptions/payment-method',
  paymentResult: '/subscriptions/payment-result',
  manualTransfer: '/subscriptions/manual-transfer',
};
